export const urls = {
  GET_MASINE_COMBO: 'Combo/vrati_tipove_masina_combo',
  GET_KARAKTERISTIKE_MASINA: 'KarakteristikeMasina/vrati_karakteristikemasina',
  DELETE_KARKTERISTIKA: 'KarakteristikeMasina/brisanje_karakteristikemasina',
  UNOS_KARKTERISTIKA: 'KarakteristikeMasina/unos_karakteristikemasina',
  IZMENA_KARKTERISTIKA: 'KarakteristikeMasina/izmena_karakteristikemasina',
};
